import BaseRoom from './BaseRoom';

import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import {
  mapActions as mapEstimateActions,
  mapGetters as mapEstimateGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';
import { mapActions as chatMapActions } from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as mapInternetMapActions,
  mapGetters as mapInternetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import {
  mapActions as areaMapActions,
  mapGetters as areaMapGetters,
} from '@common/store/modules/area';
import * as areaTypes from '@common/store/modules/area/types';

import DesignPopup from '@/common/components/modal/DesignPopup';
import EstimationListModal from './modal/EstimationListModal';
import NewBookModal from './modal/NewBookModal';
import StoreProfileModal from './modal/StoreProfile';
import UserInfoModal from './modal/UserInfoModal';
import StoreMessageModal from './modal/StoreMessageModal';
import InternetQuotationModal from './modal/InternetQuotationListModal';
import MobileEstimateModal from './modal/MobileEstimateModal';
import EstimationDetailModal from '@/front/customer/views/mypage/modal/EstimationDetailModal';
import InternetApplyVoucher from '@/front/owner/views/chat/modal/InternetApplyVoucher';
import ChatOptionModal from './modal/ChatOptionModal';
import {
  isApp,
  sleep,
  clearLocation,
  nativeLocation,
} from '@common/lib/common/utils';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

export default {
  components: {
    ...BaseRoom.components,
    EstimationDetailModal,
    EstimationListModal,
    StoreProfileModal,
    StoreMessageModal,
    UserInfoModal,
    InternetApplyVoucher,
    NewBookModal,
    DesignPopup,
    InternetQuotationModal,
    MobileEstimateModal,
    ChatOptionModal,
    DesignPopup2,
  },
  name: 'Room',
  data() {
    return {
      ...BaseRoom.data,
      chatRoomType: 'OneOnOne',
      selectedEstimation: {},
      mobileTouch: true,
      curScrollTop: 1000000000,
      shopVouchersCnt: 0,
      shopVouchersLimit: true,
      userApplyCancel: false,
      designPopup: false,
      msgPopup: '',
      isInternetOption: 'true',
      isMobileOption: 'true',
      isReviewOption: 'true',
      isUserInfoModalOpen: false,
      userInfoProfile: {},
      dupList: '', // 동일 명의로 인터넷 전송 이력 정보 ex) 24.05.06(SKT)
      ownerDupPopup: false,
      customerApplyCancelPopup: false,
      customerApplyCancelNoPopup: false,
      alreadyVoucherOpenPopup: false,
      selectApplyId: '',
      selectMobileApplyId: '',
      mobileApplyCancelPopup: false,

      lat: 0,
      lng: 0,
      geolocationAvailable: false,
      gpsUseModal: false,
      gpsOffModal: false,
      checkerId: -1,
      mobileEstimateListOpenType: '',
    };
  },
  async created() {
    localStorage.removeItem('dl_id');
    // localstorage setting
    this.isMobileOption = localStorage.getItem('isMobileOption') || 'true';
    this.isInternetOption = localStorage.getItem('isInternetOption') || 'true';
    this.isReviewOption = localStorage.getItem('isReviewOption') || 'true';

    // 채팅방 접속시 현재 위치 저장 (사용자만 해당)
    if (isApp()) {
      await this.getCurrentRegion();
    }
  },
  mounted() {
    // touchmove 일때는 클릭되지 않게 한다.
    window.addEventListener('touchmove', () => {});
    window.addEventListener('touchstart', () => {
      console.log('start');
    });
    window.addEventListener('touchcancel', () => {});
    window.addEventListener('touchend', () => {
      console.log('end');
      if (
        document.getElementById(`chatNotice`) &&
        document.getElementById(`chatScroll`)
      ) {
        const scrollTop =
          document.querySelector('#chatScroll').pageYOffset ||
          document.querySelector('#chatScroll').scrollTop;

        var someElement = document.getElementById(`chatNotice`);
        var someElement_3 = document.getElementById(`chatNotice_3`);

        if (this.curScrollTop > scrollTop) {
          someElement.classList.add('off');
          someElement_3.classList.remove('off');
        } else if (scrollTop == 0) {
          someElement.classList.add('off');
          someElement_3.classList.remove('off');
        } else if (this.curScrollTop <= scrollTop) {
          someElement.classList.remove('off');
          someElement_3.classList.add('off');
        } else {
          someElement.classList.remove('off');
          someElement_3.classList.add('off');
        }

        this.curScrollTop = scrollTop;
      }
    });
  },
  destroyed() {
    window.removeEventListener('touchmove', () => {});
    window.removeEventListener('touchstart', () => {});
    window.removeEventListener('touchcancel', () => {});
    window.removeEventListener('touchend', () => {});
  },
  computed: {
    ...BaseRoom.computed,
    ...userMapGetters({
      userAuthArea: userTypes.USER_AUTH_AREA,
      userStatus: userTypes.USER_STATUS,
    }),
    ...shopMapGetters({
      shop: shopTypes.SHOP,
      vouchersUseResult: shopTypes.SHOP_VOUCHERS_USE_RESULT,
    }),
    ...mapEstimateGetters({
      estimation: estimationTypes.ESTIMATION,
      autoEstimation: estimationTypes.AUTO_ESTIMATION,
    }),
    ...mapInternetMapGetters({
      internetChatQuotationList: internetTypes.INTERNET_CHAT_QUOTATION_LIST,
    }),
    ...mobileMapGetters({
      mobileChatEstimateList: mobileTypes.MOBILE_CHAT_ESTIMATE_LIST,
    }),
    isCustomer() {
      return process.env.VUE_APP_APP_NAME === 'customer';
    },
  },
  async beforeRouteEnter(to, from, next) {
    return BaseRoom.beforeRouteEnter(to, from, next);
  },
  beforeDestroy() {
    BaseRoom.beforeDestroy(this);
    this[commonActions.SET_CUSTOM_HEADER_TEXT](undefined);
  },
  methods: {
    ...BaseRoom.methods,
    ...commonMapActions([commonActions.SET_CUSTOM_HEADER_TEXT]),
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_CHAT_ESTIMATE_LIST,
      mobileTypes.UPDATE_MOBILE_APPLY_CANCEL,
    ]),
    ...userMapActions([
      userTypes.FETCH_AUTH_AREA,
      userTypes.FETCH_USER_STATUS,
      userTypes.FETCH_USER_CURRENT_AREA,
      userTypes.SET_USER_CURRENT_AREA,
    ]),
    ...shopMapActions([
      shopTypes.FETCH_SHOP,
      shopTypes.SHOP_FOLLOW,
      shopTypes.SHOP_UNFOLLOW,
      shopTypes.FETCH_SHOP_VOUCHERS_COUNT,
      shopTypes.FETCH_SHOP_VOUCHERS_USE,
    ]),
    ...mapEstimateActions([
      estimationTypes.FETCH_ESTIMATION,
      estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS,
      estimationTypes.SET_AUTO_ESTIMATION,
      estimationTypes.DELETE_ESTIMATION,
      estimationTypes.SET_QUOTATION,
    ]),
    ...chatMapActions([chatActions.MESSAGE_NOTICE]),
    ...mapInternetMapActions([
      internetTypes.SELECT_INTERNET_CHAT_QUOTATION_LIST,
      internetTypes.SELECT_INTERNET_APPLY_CHECK_LIMIT,
      internetTypes.SELECT_INTERNET_APPLY_CHECK_VALIDATE,
      internetTypes.SET_INTERNET_APPLY_CANCEL,
    ]),
    ...areaMapActions([
      areaTypes.FETCH_CURRENT,
      areaTypes.FETCH_DONG,
      areaTypes.AREA_RESET_STATE,
    ]),

    async getCurrentRegion() {
      if (process.env.VUE_APP_APP_NAME === 'customer') {
        await this.handleRefresh();
        if (this.geolocationAvailable) {
          if (
            this.lat == 0 ||
            this.lat == null ||
            this.lng == 0 ||
            this.lng == null
          ) {
            console.log('null');
          } else {
            const param = {
              latitude: this.lat,
              longitude: this.lng,
            };
            await this[userTypes.SET_USER_CURRENT_AREA](param);
          }
        }
      }
    },

    async handleRefresh() {
      if (!isApp()) {
        if (this.$geolocation.checkSupport()) {
          const currentPosition = await this.$geolocation.getCurrentPosition();
          if (currentPosition) {
            console.log(currentPosition);
            this.lat = currentPosition.coords.latitude;
            this.lng = currentPosition.coords.longitude;
            this.geolocationAvailable = true;
          }
        }
      } else {
        clearLocation();
        nativeLocation();
        await sleep(1000);
        //alert('location.code: ' + window.$bridge.location.code);
        if (window.$bridge.location.code !== undefined) {
          // GPS 켜져있을때 : 1, 꺼져있을 때 -1
          if (window.$bridge.location.code === '1') {
            this.lat = window.$bridge.location.latitude;
            this.lng = window.$bridge.location.longitude;
            this.geolocationAvailable = true;
          }
        }
      }
    },

    // 자주쓰는문구 선택시 채팅창에 등록
    storeMsg(msg) {
      this.message = msg;
    },

    // 채팅 입력창 줄바꿈 처리
    textareaMessage(e) {
      if (isApp()) {
        this.$refs.textbox.style.height = 'auto';
        this.$refs.textbox.style.height =
          this.$refs.textbox.scrollHeight + 'px';
      } else {
        e.preventDefault();
        if (e.keyCode === 13) {
          if (!e.shiftKey) {
            this.message = this.message.trim();
            if (this.message != '') {
              this.sendMessage('TEXT');
              this.$nextTick(() => {
                this.$refs.textbox.style.height = '4rem';
                this.$refs.textbox.value = '';
                this.message = '';
              });
            }
          } else {
            this.$refs.textbox.style.height = 'auto';
            this.$refs.textbox.style.height =
              this.$refs.textbox.scrollHeight + 'px';
          }
        }
      }

      const textbox_val = this.$refs.textbox.value.trim();
      // 채팅메시지 임시 저장
      localStorage.setItem(`chatroom-input-${this.uuid}`, textbox_val);
    },

    // 자주쓰는 문구 선택시 채팅 입력창 줄바꿈 처리
    textareaMessageSel(e) {
      const valueLength = this.$refs.textbox.value.length;
      const valueArr = this.$refs.textbox.value.split('\n');
      const valueArrCnt = valueArr.length;
      console.log(this.$refs.textbox.value);
      console.log(valueLength);
      console.log(valueArr);
      console.log(valueArrCnt);

      // if (valueArrCnt >= 2 || valueLength > 18) {
      //   this.$refs.textbox.style.height = '8rem';
      //   this.$refs.chat_write_wrap.style.height = 'auto';
      // } else {
      //   this.$refs.textbox.style.height = '4rem';
      //   this.$refs.chat_write_wrap.style.height = '5.4rem';
      // }

      const textbox_val = this.$refs.textbox.value.trim();
      // 채팅메시지 임시 저장
      localStorage.setItem(`chatroom-input-${this.uuid}`, textbox_val);
    },

    //채팅룸 정보
    async initFetch() {
      //상점정보 가져오기.
      await this.getStoreInfo();
      //채팅방 정보 가져오기.
      await this.getChatRoom();
      await this.setChatRoom();

      // await this.getVoucherCnt(this.chatroom.id);

      console.log('this.chatroomthis.chatroomthis.chatroom');
      console.log(this.chatroom);

      let now = new Date();
      var week = new Array('7', '1', '2', '3', '4', '5', '6'); // 일, 월, 화, 수, 목, 금, 토

      let hours = now.getHours(); // 시
      let minutes = now.getMinutes(); // 분

      var startTime = this.shop.counselStart.split(':');
      var endTime = this.shop.counselEnd.split(':');

      console.log(hours);
      console.log(startTime[0]);
      console.log(endTime[0]);

      // 있음, 영업함
      if (this.shop.counselDay.indexOf(week[now.getDay()]) !== -1) {
        // 시간 확인
        if (parseInt(startTime[0]) <= hours && parseInt(endTime[0]) >= hours) {
          if (parseInt(endTime[1]) < minutes && parseInt(endTime[0]) == hours) {
            this.isChatBtn = false;
          } else {
            this.isChatBtn = true;
          }
        } else {
          this.isChatBtn = false;
        }
      } else {
        this.isChatBtn = false;
      }

      this.isChatBtnView = true;
    },
    //상점정보 가져오기.
    async getStoreInfo() {
      //console.log('getSotreInfo', this.storeId, this.chatroom);
      if (this.chatroom && this.chatroom.store && this.chatroom.store.id) {
        this.storeId = this.chatroom.store.id;
      }
      //console.log('getSotreInfo', this.storeId);
      if (this.storeId) {
        // if (!this.shop || this.shop.id == 0) {
        await this[shopTypes.FETCH_SHOP]({ id: this.storeId });
        // }
        this.setTitle();
      }
    },
    async getVoucherCnt(applyId) {
      var shopVouchers = await this[
        internetTypes.SELECT_INTERNET_APPLY_CHECK_LIMIT
      ]({
        applyId: applyId,
      });

      console.log('shopVouchers');
      console.log(shopVouchers);

      this.shopVouchersCnt = shopVouchers.voucherCnt;
      this.shopVouchersLimit = shopVouchers.limit;
      this.userApplyCancel = shopVouchers.cancel;
    },
    async voucherUse(applyId) {
      if (applyId > 0) {
        try {
          const params = {
            applyId: applyId,
          };
          this[shopTypes.FETCH_SHOP_VOUCHERS_USE](params)
            .then(() => {
              console.log(this.vouchersUseResult);
              // 성공
              if (this.vouchersUseResult.resultCd == 'S') {
                console.log('바우처 사용 성공');
                // 시스템 메세지 추가
                this.createVoucherSystemMessage();
                this.$router.push({
                  // name: 'InternetCommerce.ApplyForm',
                  // params: { mode: 'detail', id: applyId },
                  name: 'InternetCommerce.ApplyDetail',
                  params: { id: applyId, title: '인터넷 가입 신청서' },
                });
              } else {
                console.log('바우처 사용 실패');
                this.msgPopup = this.vouchersUseResult.resultMsg;
                this.designPopup = true;
              }
            })
            .catch(() => {
              console.log('error');
            });
        } catch (e) {
          console.log('error');
        }
      }
    },
    async createVoucherSystemMessage() {
      let sendType = 'internetVoucherOpenNotice';
      // KT 프로모션 4485
      // if (this.storeId == '3067') {
      if (this.storeId == '4485') {
        sendType = 'internetPromotionKT2408OpenNotice';
      }

      const params = {
        userId:
          this.chatroom.chatMembers[0].user.roles === '21'
            ? this.chatroom.chatMembers[1].userId
            : this.chatroom.chatMembers[0].userId,
        storeId: this.storeId,
        sendType: sendType,
      };
      this[chatActions.MESSAGE_NOTICE](params);
    },
    designPopupclose() {
      this.designPopup = false;
    },
    //채팅방 정보 가져오기.
    async getChatRoom() {
      if (this.isCreateMode) {
        await this[chatActions.FETCH_CHATROOM_WITH_STORE]({
          chatRoomType: this.chatRoomType,
          storeId: this.storeId,
        });
      } else {
        await this[chatActions.FETCH_CHATROOM]({
          uuid: this.uuid,
        });

        await this[chatActions.FETCH_CHATROOM_WATCH]({
          chatRoomId: this.chatroom.id,
        }).then(() => {
          console.log('chatroom_watch_getChatRoom');
          console.log(this.chatroom_watch);
        });
      }
    },
    async setChatRoom(isFromCreate) {
      if (this.isCreateMode) {
        if (this.chatrooms_with.count === 0) {
          if (!this.shop.followed) {
            this[chatActions.SET_CHATMESSAGES_BY_MESSAGE_IDX]({
              messages: [
                {
                  type: 'ASK_FOLLOW',
                  message: JSON.stringify({
                    text:
                      '퍼스의 주요한 기능을 사용해보세요\n1. 관심매장 등록 후 자동견적 요청하기 (첨부기능)\n2. 매장에게 전용 견적서를 받고서 후기 작성하기',
                  }),
                  messageIdx: 0.1,
                  createdAt: new Date().toISOString(),
                },
              ],
            });
          }
          this[chatActions.SET_CHATMESSAGES_BY_MESSAGE_IDX]({
            messages: [
              {
                type: 'ASK_ESTIMATE',
                message: JSON.stringify({
                  text:
                    '#<#txtColor#>## 상담하시기 전에 견적요청서를 보내셔야\n#<#txtColor#>#더욱 빠른 상담이 가능합니다. (별첨가능)',
                }),
                messageIdx: 0.2,
                createdAt: new Date().toISOString(),
              },
            ],
            append: true,
          });
          this.messages = this.chatmessages;
        } else {
          if (this.chatrooms_with.content[0].leave) {
            if (!this.shop.followed) {
              this[chatActions.SET_CHATMESSAGES_BY_MESSAGE_IDX]({
                messages: [
                  {
                    type: 'ASK_FOLLOW',
                    message: JSON.stringify({
                      text:
                        '퍼스의 주요한 기능을 사용해보세요\n1. 관심매장 등록 후 자동견적 요청하기 (첨부기능)\n2. 매장에게 전용 견적서를 받고서 후기 작성하기',
                    }),
                    messageIdx: 0.1,
                    createdAt: new Date().toISOString(),
                  },
                ],
              });
            }
            this[chatActions.SET_CHATMESSAGES_BY_MESSAGE_IDX]({
              messages: [
                {
                  type: 'ASK_ESTIMATE',
                  message: JSON.stringify({
                    text:
                      '#<#txtColor#>## 상담하시기 전에 견적요청서를 보내셔야\n#<#txtColor#>#더욱 빠른 상담이 가능합니다. (별첨가능)',
                  }),
                  messageIdx: 0.2,
                  createdAt: new Date().toISOString(),
                },
              ],
              append: true,
            });
            this.messages = this.chatmessages;
          } else {
            this.$router.replace({
              name: 'chat.room',
              params: {
                uuid: this.chatrooms_with.content[0].uuid,
              },
            });
          }
        }
      } else {
        this.messageIdx = this.chatroom.messageIdx;
        await this.getStoreInfo();
        await this.getAutoEstimateInProgress();
        await this.syncChatRoom();
        if (!isFromCreate) this.infiniteId += 1; //리스트 가져오기.
      }
    },
    //진행중인 자동견적요청서 가져오기.
    async getAutoEstimateInProgress() {
      await this[estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]({
        userId: this.currentUser.id,
        storeId: this.storeId,
      });
    },
    setTitle() {
      let title = '';
      if (process.env.VUE_APP_APP_NAME === 'customer') {
        if (this.chatroom && this.chatroom.store) {
          title = this.chatroom.store.name;
        } else {
          title = this.shop.name;
        }
      } else {
        const customer = this.chatroom.chatMembers.find(
          m => m.user.roles !== '21',
        );
        title = customer.user.nickname || customer.user.mobileNumber;
      }

      this[commonActions.SET_CUSTOM_HEADER_TEXT](title);
      //document.getElementById('headerTitle').innerHTML = storeName;
      //console.log(this.$parent, this.$root);
    },
    //채팅방 생성
    async createChatRoom(estimation) {
      await this[chatActions.CREATE_CHATROOM]({
        chatRoomType: this.chatRoomType,
        memberId: this.shop.userId,
        storeId: this.shop.id,
        estimateId: estimation ? estimation.id : undefined,
      });
      //채팅룸 생성 완료
      const dt = new Date().toISOString();
      /*await this[chatActions.SET_CHATMESSAGES_BY_MESSAGE_IDX]({
        messages: [
          {
            type: 'DATE',
            message: JSON.stringify({
              date: format(parseISO(dt), 'yyyy-MM-dd'),
            }),
            messageIdx: 0.3,
            createdAt: dt,
          },
        ],
        append: true,
      });

      await this[chatActions.RECEIVE_CHATMESSAGE]({
        uuid: this.chatroom.uuid,
        messageIdx: 0.3,
        messages: this.chatmessages.flatMap(m => {
          m.message = JSON.stringify(m.message);
          return m;
        }),
        append: true,
        skipStore: true,
      });*/

      this.$router.replace({
        name: 'chat.room',
        params: {
          uuid: this.chatroom.uuid,
        },
      });
    },
    //다른페이지에서 액션 후 사후처리
    async handlePostProcessing() {
      // if (this.postProcessing !== {}) {
      if (this.postProcessing.length > 0) {
        if (this.postProcessing.estimate) {
          this.sendMessage('SYSTEM', {
            text: '자동견적서가 신청되었습니다.',
            estimateId: this.postProcessing.estimate.id,
          });
        } else if (this.postProcessing.quotations) {
          this.sendMessage('QUOTATION', {
            quotation: this.postProcessing.quotations[0],
          });
        }
        this[chatActions.SET_POST_PROCESSING]({});
      }
    },
    openEstimationListModal() {
      this.$refs.estimationListModal.isOpen = true;
    },
    closeEstimationListModal() {
      this.$refs.estimationListModal.isOpen = false;
    },

    // 사전예약 열기 (hsh)
    openNewBookModal() {
      this.$refs.newBookModal.isOpen = true;
      this.$refs.newBookModal.isSendButton = true;
      this.closeAttachmentModal();
    },
    closeNewBookModal() {
      this.$refs.newBookModal.isOpen = false;
      this.closeAttachmentModal();
    },

    // 자주쓰는문구 열기 (채팅창에서) (hsh)
    openChatMessageListModal() {
      this.$refs.storeChatMessageModal.isOpen = true;
      this.$refs.storeChatMessageModal.$refs.modal_close.style.display =
        'block';
      this.closeAttachmentModal();
    },
    // 자주쓰는문구 닫기 (채팅창에서) (hsh)
    closeChatMessageListModal() {
      this.$refs.storeChatMessageModal.isOpen = false;
      this.$refs.storeChatMessageModal.$refs.modal_close.style.display = 'none';
      this.closeAttachmentModal();
    },

    openProfileModal(userId, userRoles, userNickName) {
      if (userRoles === '21') {
        // console.log(this.chatroom.store.id);
        // 20211216 사용자 채팅방에서 프로필 사진 클릭시 매장 상세페이지로 이동 처리 (hsh)
        this.$router.push({
          name: 'Shops.Detail',
          params: {
            id: this.chatroom.store.id,
          },
        });
        return;
        // 20211216 사용자 채팅방에서 프로필 사진 클릭시 매장 정보 노출 부분 안나오게 처리 (hsh)
        //this.openStoreProfileModal();
      } else {
        // this.openUserProfileModal(userId);
        this.openUserInfoModal(userId, userNickName);
      }
    },

    // 사장님이 채팅방에서 사용자프로필사진 선택시 뜨는 팝업창 (hsh_20220203)
    async openUserInfoModal(userId, userNickName) {
      // isUserInfoModalOpen
      // userInfoProfile

      // await this[userTypes.FETCH_AUTH_AREA]({ id: userId });
      // let message = '';
      // if (this.userAuthArea && this.userAuthArea.length > 0) {
      //   message = '우리동네 위치로 확인된 이용자입니다.';
      // } else {
      //   message = '';
      // }

      // 현재위치
      await this[userTypes.FETCH_USER_CURRENT_AREA]({ userId: userId }).then(
        res => {
          console.log('FETCH_USER_CURRENT_AREA');
          console.log(res);

          if (res.trim()) {
            let txtArr = res.split(' ');
            if (res.indexOf('특별시') !== -1 || res.indexOf('광역시') !== -1) {
              this.userInfoProfile.userCurrentArea = txtArr[0];
            } else {
              this.userInfoProfile.userCurrentArea =
                txtArr[0] + ' ' + txtArr[1];
            }
          } else {
            this.userInfoProfile.userCurrentArea = '';
          }
        },
      );

      await this[userTypes.FETCH_USER_STATUS]({ id: userId });
      console.log('this.userStatus');
      console.log(this.userStatus);

      this.userInfoProfile.accessMinute = this.userStatus.accessMinute;
      this.userInfoProfile.chatCnt = this.userStatus.chatCnt;
      this.userInfoProfile.followCnt = this.userStatus.followCnt;
      this.userInfoProfile.reviewCnt = this.userStatus.reviewCnt;
      this.userInfoProfile.internetCommerceCnt = this.userStatus.internetCommerceCnt;
      this.userInfoProfile.mobileRequestCnt = this.userStatus.mobileRequestCnt;

      // this.userInfoProfile.message = message;
      this.userInfoProfile.userNickName = userNickName;

      this.userInfoProfile.weeklySameApplyList = this.userStatus.weeklySameApplyList;
      this.userInfoProfile.monthlySameApplyList = this.userStatus.monthlySameApplyList;

      if (
        this.userStatus.deviceModelName != null &&
        this.userStatus.deviceModelName != '' &&
        this.userStatus.telecomName != null &&
        this.userStatus.telecomName != ''
      ) {
        const modelName = this.userStatus.deviceModelName.split('의 ');
        console.log(modelName);
        this.userInfoProfile.myDeviceName =
          modelName.length == 1
            ? this.userStatus.deviceModelName
            : modelName[1];
        this.userInfoProfile.myTelecomName = this.userStatus.telecomName;
      }

      this.isUserInfoModalOpen = true;
    },
    closeUserInfoModal() {
      this.isUserInfoModalOpen = false;
    },

    openStoreProfileModal() {
      this.$refs.storeProfileModal.isOpen = true;
      this.$refs.storeProfileModal.store = this.chatroom.store;
    },
    closeStoreProfileModal() {
      this.$refs.storeProfileModal.isOpen = false;
    },
    async openUserProfileModal(userId) {
      await this[userTypes.FETCH_AUTH_AREA]({ id: userId });
      let message = '';
      if (this.userAuthArea && this.userAuthArea.length > 0) {
        message = '우리동네 위치로 확인된 이용자입니다.';
      } else {
        message = '위치 확인이 불가능한 이용자입니다.';
      }
      this[commonActions.SET_DIALOG]({
        type: 'normal',
        icon: 'warning',
        //title: this.$t('common.confirm'),
        message,
        okCb: async () => {},
      });
    },

    async openEstimationDetailModal(estimateId) {
      const data = await this[estimationTypes.FETCH_ESTIMATION]({
        id: estimateId,
      });
      this.selectedEstimation = data;
      this.$refs.estimationDetailModal.item = this.estimation;
      this.$refs.estimationDetailModal.isOpen = true;
    },
    closeEstimationDetailModal() {
      this.$refs.estimationDetailModal.isOpen = false;
      this.closeAttachmentModal();
    },

    sendEstimation(item) {
      this.selectedEstimation = item;
      this.$refs.estimationListModal.isOpen = false;

      if (this.isCreateMode) {
        this.createChatRoom(item);
      } else {
        this.sendMessage('ESTIMATE', { estimateId: item.id });
      }
      this.closeEstimationDetailModal();
    },
    async cancelEstimationAuto() {
      if (this.autoEstimation) {
        await this[estimationTypes.DELETE_ESTIMATION]({
          id: this.autoEstimation.id,
        });
        this.sendMessage('SYSTEM', {
          text: '자동견적서가 취소되었습니다.',
          estimateId: this.autoEstimation.id,
        });
        this[estimationTypes.SET_AUTO_ESTIMATION](null);
        this.closeAttachmentModal();
      }
    },
    // openQuotation(quotation) {
    //   quotation.isDetail = true;
    //   this[estimationTypes.SET_QUOTATION](quotation);
    //   this.$router.push({
    //     name: 'Estimation.PreviewQuotation',
    //     params: { title: this.chatroom.store.name },
    //   });
    // },
    openMobileDetail(mobileRequest, isCustomer) {
      console.log(mobileRequest);
      const query = {
        requestId: mobileRequest.requestId,
        estimateId: mobileRequest.estimateId,
      };
      console.log('openMobileDetail = query');
      console.log(query);

      this.$router.push({
        name: 'Mobile.EstimateDetail',
        query: query,
      });
    },
    openMobileEstimateDetail(mobileEstimate, isCustomer) {
      console.log(mobileEstimate);
      const query = {
        requestId: mobileEstimate.requestId,
        estimateId: mobileEstimate.estimateId,
      };
      console.log('openMobileEstimateDetail = query');
      console.log(query);

      this.$router.push({
        name: 'Mobile.EstimateDetail',
        query: query,
      });
    },
    openMobilePromiseReg(chatRoom) {
      const query = {
        storeId: chatRoom.store.id,
        chatRoomId: chatRoom.id,
        chatRoomUuid: chatRoom.uuid,
      };

      this.$router.push({ name: 'Mobile.Promise', query: query });
    },

    openMobilePromiseView(visitPromise, isCustomer) {
      let query = { promiseId: visitPromise.promiseId };
      if (isCustomer) query.customer = true;
      this.$router.push({ name: 'Mobile.Promise', query: query });
    },
    openPromiseModal(chatRoom) {
      console.log('openPromiseModal');
      console.log(chatRoom);

      this.openMobilePromiseReg(chatRoom);
    },
    async openInternetApplyAddress(applyId) {
      // this.$router.push({
      //   name: 'InternetCommerce.ApplyForm',
      //   params: {
      //     mode: 'detail',
      //     id: applyId,
      //     hideInfo: true,
      //     storeId: this.storeId,
      //     chatRoomId: this.chatroom.id,
      //     userId:
      //       this.chatroom.chatMembers[0].user.roles === '21'
      //         ? this.chatroom.chatMembers[1].userId
      //         : this.chatroom.chatMembers[0].userId,
      //   },
      // });
      this.$router.push({
        name: 'InternetCommerce.ApplyDetail',
        params: {
          id: applyId,
          hideInfo: true,
          title: '인터넷 가입 신청서',
          userId:
            this.chatroom.chatMembers[0].user.roles === '21'
              ? this.chatroom.chatMembers[1].userId
              : this.chatroom.chatMembers[0].userId,
        },
      });
    },
    async dupCheckInfo(applyId) {
      // 동일 견적 요청서의 동일 명의로 신청 내역이 있는지 확인(사장님)
      this.selectApplyId = applyId;
      await this[internetTypes.SELECT_INTERNET_APPLY_CHECK_VALIDATE]({
        applyId: applyId,
      }).then(res => {
        const applyCnt = res.applyCnt;
        const applyList = res.applyList;
        if (applyCnt > 0) {
          this.dupList = applyList;
          this.ownerDupPopup = true;
        } else {
          this.openInternetApplyVoucher(applyId);
        }
      });
    },
    ownerDupPopupClose(checked) {
      if (checked) {
        this.openInternetApplyVoucher(this.selectApplyId);
      }
      this.ownerDupPopup = false;
    },
    customerApplyCancelPopupOpen(applyId) {
      this.selectApplyId = applyId;
      this.customerApplyCancelPopup = true;
    },
    customerApplyCancelPopupClose(checked) {
      if (checked) {
        this.setUserApplyCancel(this.selectApplyId);
      }
      this.customerApplyCancelPopup = false;
    },
    customerApplyCancelNoPopupOpen() {
      this.customerApplyCancelNoPopup = true;
    },
    customerApplyCancelNoPopupClose() {
      this.customerApplyCancelNoPopup = false;
      this.$router.go(this.$router.currentRoute);
    },
    alreadyVoucherOpenPopupOpen() {
      this.alreadyVoucherOpenPopup = true;
    },
    alreadyVoucherOpenPopupClose() {
      this.alreadyVoucherOpenPopup = false;
      this.$router.go(this.$router.currentRoute);
    },
    openMobileApplyCancel(applyId) {
      this.selectMobileApplyId = applyId;
      this.mobileApplyCancelPopup = true;
    },
    mobileApplyCancelPopupClose(checked) {
      if (checked) {
        this.setUserMobileApplyCancel(this.selectMobileApplyId);
      }
      this.mobileApplyCancelPopup = false;
    },
    setUserMobileApplyCancel(applyId) {
      this[mobileTypes.UPDATE_MOBILE_APPLY_CANCEL]({
        id: applyId,
      }).then(res => {
        console.log('setUserMobileApplyCancel');
        console.log(res);
        if (res.resultCd == 'SUCCESS') {
          this.$router.go(this.$router.currentRoute);
        } else if (res.resultCd == 'VIEWED') {
          this.alreadyVoucherOpenPopupOpen();
        } else {
          alert('취소 실패');
          this.$router.go(this.$router.currentRoute);
        }
      });
    },
    setUserApplyCancel(applyId) {
      this[internetTypes.SET_INTERNET_APPLY_CANCEL]({
        id: applyId,
      }).then(res => {
        console.log('setUserApplyCancel');
        console.log(res);
        if (res.resultCd == 'SUCCESS') {
          this.$router.go(this.$router.currentRoute);
        } else if (res.resultCd == 'VIEWED') {
          this.alreadyVoucherOpenPopupOpen();
        } else {
          alert('취소 실패');
          this.$router.go(this.$router.currentRoute);
        }
      });
    },
    async openInternetApplyVoucher(applyId) {
      console.log('room_____openInternetApplyVoucher');
      console.log(this.chatroom);
      // limit = true면 제한
      await this.getVoucherCnt(applyId);

      if (this.userApplyCancel) {
        this.customerApplyCancelNoPopupOpen();
      } else {
        if (this.shopVouchersLimit) {
          this.$refs.internetApplyVoucher.$refs.modal_close.style.display =
            'block';
          this.$refs.internetApplyVoucher.applyId = applyId;
          this.$refs.internetApplyVoucher.isOpen = true;
        } else {
          // 바로 신청서 열람하기
          this.$router.push({
            // name: 'InternetCommerce.ApplyForm',
            // params: { mode: 'detail', id: applyId },
            name: 'InternetCommerce.ApplyDetail',
            params: { id: applyId, title: '인터넷 가입 신청서' },
          });
        }
      }
    },
    closeInternetApplyVoucherModal() {
      this.$refs.internetApplyVoucher.$refs.modal_close.style.display = 'none';
      this.$refs.internetApplyVoucher.isOpen = false;
    },
    sendAutoMessage(message) {
      this.message = message;
      this.sendMessage('TEXT');
    },
    openChatOptionModal(val) {
      let title = '';
      if (val === 'Internet') {
        title = '인터넷 가입신청서 버튼을 숨길까요?';
      } else if (val === 'Mobile') {
        title = '휴대폰 방문약속 버튼을 숨길까요?';
      } else if (val === 'Review') {
        title = '매장 평가하기 버튼을 숨길까요?';
      }
      this.$refs.ChatOptionModal.isOpen = true;
      this.$refs.ChatOptionModal.type = val;
      this.$refs.ChatOptionModal.title = title;
    },
    closeOptionModal(dataType, type) {
      if (dataType) {
        localStorage.setItem(`is${type}Option`, 'false');
        if (type === 'Internet') {
          this.isInternetOption = 'false';
        } else if (type === 'Mobile') {
          this.isMobileOption = 'false';
        } else if (type === 'Review') {
          this.isReviewOption = 'false';
        }
      }
      this.$refs.ChatOptionModal.isOpen = false;
    },
    openEvaluationStoreModal() {
      this.$refs.ChatEvaluationStoreModal.isOpen = true;
    },
    closeEvaluationStoreModal(dataType) {
      if (dataType) {
        localStorage.setItem('isStoreReview', 'false');
        this.isStoreReview = 'false';
      }
      this.$refs.ChatEvaluationStoreModal.isOpen = false;
    },
    openMobileApplyForm(estimateId, openType) {
      let title = '휴대폰 개통신청서';
      if (openType == 'VISIT') {
        title = '휴대폰 개통신청서(매장방문)';
      } else if (openType == 'ONLINE') {
        title = '휴대폰 개통신청서(비대면)';
      }
      const params = {
        estimateId: estimateId,
        openType: openType, // VISIT, ONLINE
        mode: 'FORM',
        title: title,
      };

      this.$router.push({ name: 'Mobile.ApplyForm', params: params });
    },
    async openMobileEstimateList(chatRoom, openType) {
      console.log('openMobileEstimateList');
      console.log(chatRoom);
      console.log(openType); // VISIT, ONLINE
      this.$refs.MobileEstimateModal.isOpen = true;
      await this[mobileTypes.SELECT_MOBILE_CHAT_ESTIMATE_LIST]({
        chatroomId: chatRoom.id,
        openType: openType,
      });

      this.mobileEstimateListOpenType = openType;
      console.log('this.mobileChatEstimateList');
      console.log(this.mobileChatEstimateList);
    },
    closeMobileEstimateModal(dataType, estimateId) {
      if (dataType) {
        this.openMobileApplyForm(estimateId, this.mobileEstimateListOpenType);
      }
      this.$refs.MobileEstimateModal.isOpen = false;
    },
    openInternetQuotationList() {
      this.$refs.InternetQuotationModal.isOpen = true;
      this[internetTypes.SELECT_INTERNET_CHAT_QUOTATION_LIST]({
        chatroomId: this.chatroom.id,
      });
    },
    closeInternetQuotationModal(dataType, icqId) {
      if (dataType) {
        this.$router.push({
          name: 'InternetCommerce.ApplyForm',
          params: {
            mode: 'submit',
            storeId: this.chatroom.store.id,
            icqId: icqId,
          },
        });
      }
      this.$refs.InternetQuotationModal.isOpen = false;
    },
    reviewStore() {
      this.$router.push({
        name: 'Shops.Reviews',
        params: { id: this.storeId },
        query: { type: 'normal' },
      });
    },
    async getShopVouchersLimit(applyId) {
      // alert(applyId);
      // return this.$emit('getShopVouchersLimit', applyId);
      await this.getVoucherCnt(applyId);
    },
    test() {
      this.messages.push([
        {
          type: 'ASK_FOLLOW',
          message: {
            text: '관심매장으로 설정하시면\n다양한 혜택이 자동으로 수신됩니다.',
          },
          createdAt: '2021-04-01T21:26:00Z',
        },
      ]);
      this.messages.push([
        {
          type: 'ASK_ESTIMATE',
          message: {
            text:
              '상담하시기 전에 요청서를 먼저 보내면\n더욱 편리한 상담이 가능합니다.',
          },
          createdAt: '2021-04-01T21:26:00Z',
        },
      ]);
      this.messages.push([
        {
          type: 'DATE',
          message: {
            date: '2021-05-26',
          },
          createdAt: '2021-04-01T21:26:00Z',
        },
      ]);
      this.messages.push([
        {
          type: 'SYSTEM',
          message: {
            text:
              '"xxx"님이 요청서 없이\n바로 채팅.... 문의하셨습니다. 좋은 상담 이어가세요.',
          },
          createdAt: '2021-04-01T21:26:00Z',
        },
      ]);
      this.messages.push([
        {
          type: 'SYSTEM',
          message: {
            text:
              '"xxx"님이 요청서를 보내왔습니다.\n내용 확인하시어 좋은 상담 이어가세요.',
          },
          createdAt: '2021-04-01T21:26:00Z',
        },
      ]);
      this.messages.push([
        {
          type: 'SYSTEM',
          message: {
            text: '자동견적서가 신청되었습니다.',
          },
          createdAt: '2021-04-01T21:26:00Z',
        },
      ]);
      this.messages.push([
        {
          type: 'SYSTEM',
          message: {
            text: '자동 견적서 수신 기간이 종료되었습니다.',
          },
          createdAt: '2021-04-01T21:26:00Z',
        },
      ]);
      this.messages.push([
        {
          type: 'ESTIMATE',
          message: {
            text: '요청서입니다.',
          },
          userId: 4,
          createdAt: '2021-04-01T21:26:19Z',
        },
      ]);
      this.messages.push([
        {
          type: 'TEXT',
          message: {
            text: '안녕하세요 제로모바일입니다.',
          },
          //time: 1621977600,
          createdAt: '2021-04-01T21:26:19Z',
        },
        {
          type: 'IMAGE',
          message: {
            image:
              'https://imgsv.imaging.nikon.com/lineup/dslr/df/img/sample/img_01.jpg',
          },
          //time: 1621977600,
          createdAt: '2021-04-01T21:26:19Z',
        },
        {
          type: 'TEXT',
          message: {
            text: '반갑습니다.',
          },
          //time: 1621977600,
          createdAt: '2021-04-01T21:26:19Z',
        },
      ]);
      this.messages.push([
        {
          type: 'QUOTATION',
          message: {
            text: '견적서입니다.',
          },
          userId: 19,
          createdAt: '2021-04-01T21:26:19Z',
        },
      ]);
    },
  },
};
